/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class WaitingListApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Add an email to a waiting list
     * @param id 
     * @param body 
     */
    public addToWaitingList(id?: string, body?: models.ApiPostWaitingLists, __unused?: any): Observable<models.ApiWaitingListEntry> {
        const path = '/waiting_lists/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiWaitingListEntry>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Confirm an entry on the waiting list
     * @param id 
     * @param entry_id 
     * @param body 
     */
    public confirmEntry(id?: string, entry_id?: number, body?: models.ApiPostWaitingListsIdEntriesEntryIdConfirm, __unused?: any): Observable<models.ApiWaitingListEntryWithEmail> {
        const path = '/waiting_lists/{id}/entries/{entry_id}/confirm'
                    .replace('{' + 'id' + '}', String(id))
                    .replace('{' + 'entry_id' + '}', String(entry_id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiWaitingListEntryWithEmail>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Get an entry on the waiting list
     * @param id 
     * @param entry_id 
     * @param body 
     */
    public getEntry(id?: string, entry_id?: number, body?: models.ApiPostWaitingListsIdEntries, __unused?: any): Observable<models.ApiWaitingListEntryWithEmail> {
        const path = '/waiting_lists/{id}/entries/{entry_id}'
                    .replace('{' + 'id' + '}', String(id))
                    .replace('{' + 'entry_id' + '}', String(entry_id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiWaitingListEntryWithEmail>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

}
